// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_9137520","form":"_216ecf9","pagination":"_ac5d7f9","buttonsWrapper":"_4cb653e"};